export * from './http-status-codes';
export * from './in-memory-backend.service';
export * from './in-memory-web-api.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-in-memory-web-api/index.js
// module id = 735
// module chunks = 4